import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Webcam from 'react-webcam'
import { Box, Stack, Grid, Button } from '@mui/material'
import { Camera, AttachFile, Delete } from '@mui/icons-material'
import Loading from 'components/generic/Loading'
import { useGetOrgImageQuery } from 'services/assets'
import { b64toBlob } from 'utils/helpers'
import handleImageUpload from 'utils/fileUpload'

const capture = (imageRef, side, saveImage, setSrc, setIsActive) => {
  const imageSrc = imageRef.current.getScreenshot()
  const imageFile = b64toBlob(imageSrc)
  saveImage(side, imageFile, { shouldDirty: true, shouldTouch: true })

  setSrc(imageSrc)
  setIsActive(false)
}

const IdWindow = ({ side, saveImage, image }) => {
  const { data: orgImage, isLoading: isLoadingOrgImage } = useGetOrgImageQuery(
    {
      filename: image?.filename,
      isTemp: false,
    },
    { skip: !image?.filename },
  )

  const imageRef = useRef(null)
  const [isActive, setIsActive] = useState(false)
  const [src, setSrc] = useState(null)

  useEffect(() => {
    if (orgImage) {
      setSrc(orgImage)
    }
  }, [orgImage])

  const renderImageWindow = () => {
    let element
    if (isLoadingOrgImage) {
      element = <Loading localized localizedSx={{ height: '100%' }} />
    } else if (src) {
      element = (
        <img
          src={src}
          alt={`${side}-of-license`}
          style={{
            height: 218,
            width: 342,
            objectFit: 'contain',
          }}
        />
      )
    } else if (isActive) {
      element = (
        <Webcam
          ref={imageRef}
          screenshotFormat="image/jpeg"
          screenshotQuality={1}
          forceScreenshotSourceSize
          height={218}
          width={342}
          videoConstraints={{
            height: 1100,
            width: 1710,
            facingMode: 'environment',
          }}
        />
      )
    }
    return element
  }

  const renderButtons = () => {
    let buttons

    if (src) {
      buttons = (
        <>
          <Button
            variant="text"
            onClick={() => {
              setSrc(null)
              saveImage(side, null, { shouldDirty: true, shouldTouch: true })
            }}
            startIcon={<Delete />}
            color="error"
          >
            Delete Photo
          </Button>
        </>
      )
    } else if (isActive) {
      buttons = (
        <>
          <Button
            variant="outlined"
            onClick={() => capture(imageRef, side, saveImage, setSrc, setIsActive)}
            startIcon={<Camera />}
          >
            Capture Image
          </Button>
        </>
      )
    } else {
      buttons = (
        <>
          <Button variant="outlined" onClick={() => setIsActive(true)} startIcon={<Camera />}>
            Take Photo
          </Button>
          <Button variant="text" onClick={() => {}} startIcon={<AttachFile />} component="label">
            Upload Photo
            <input
              type="file"
              hidden
              onChange={event => {
                handleImageUpload(event, side, saveImage, setSrc)
              }}
            />
          </Button>
        </>
      )
    }
    return buttons
  }

  return (
    <Grid item xs={5}>
      <Box
        mb={1}
        height={247}
        width={375}
        backgroundColor="rgba(0, 0, 0, 0.2)"
        borderRadius={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {renderImageWindow()}
      </Box>
      <Stack direction="row" justifyContent="center" spacing={1}>
        {renderButtons('back')}
      </Stack>
    </Grid>
  )
}

IdWindow.propTypes = {
  side: PropTypes.oneOf(['front', 'back']).isRequired,
  saveImage: PropTypes.func.isRequired,
  image: PropTypes.object,
}

IdWindow.defaultProps = {
  image: {},
}

export default IdWindow
